import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getLoginUrl, getSignupUrl } from '../../config/surface'
import { PUBLIC_LEGAL_ROUTES, type PublicLegalRouteKey } from '../../public/routes'

/** Footer — public legal links + minimal product entry (spec §21–§23). */
export default function Footer() {
  const { t } = useTranslation('legal')

  const legalLinks: { key: PublicLegalRouteKey; label: string }[] = [
    { key: 'privacy', label: t('footer.privacy') },
    { key: 'terms', label: t('footer.terms') },
    { key: 'refund', label: t('footer.refund') },
    { key: 'billing', label: t('footer.billing') },
  ]

  return (
    <footer className="mkt-footer">
      <div className="mkt-footer-inner mkt-footer-inner--legal">
        <div className="mkt-footer-col">
          <div className="mkt-footer-heading">{t('footer.legalHeading')}</div>
          <div className="mkt-footer-links">
            {legalLinks.map((item) => (
              <Link key={item.key} to={PUBLIC_LEGAL_ROUTES[item.key]}>{item.label}</Link>
            ))}
          </div>
        </div>
        <div className="mkt-footer-col">
          <div className="mkt-footer-heading">{t('footer.supportHeading')}</div>
          <div className="mkt-footer-links">
            <a href={getLoginUrl()}>Login</a>
            <a href={getSignupUrl()}>Sign Up</a>
          </div>
        </div>
        <span className="mkt-footer-copy">© {new Date().getFullYear()} Vistoera</span>
      </div>
    </footer>
  )
}
